import { Box } from "@mui/material";
import { useState } from "react";
import Section from "./Section.jsx";
import BeforeImage from "../assets/before-1.jpg";
import AfterImage from "../assets/after-1.jpg";
import ReactCompareImage from "react-compare-image";
export default function Results() {
  const [sliderPosition, setSliderPosition] = useState(50);
  const handleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percent = (x / rect.width) * 100;
    setSliderPosition(Math.min(100, Math.max(0, percent)));
  };
  return (
    <Section
      id="results"
      title="Результат"
      headerStyles={{
        color: "#5f2e20",
        textDecoration: "underline",
        textDecorationColor: "#ffd700",
        ":after": { display: "none" },
        mt: 6,
      }}
    >
      {" "}
      <Box
        sx={{ mx: "auto", py: 3, px: 2, maxWidth: "900px", maxHeight: "900px" }}
      >
        {" "}
        <ReactCompareImage
          leftImage={BeforeImage}
          rightImage={AfterImage}
        />{" "}
      </Box>{" "}
    </Section>
  );
}
